/* Josie Austin theme script. Vanilla JS, no dependencies. */
(function () {
  'use strict';

  var JA = window.JA || {};
  var routes = JA.routes || {};
  var qs = function (sel, root) { return (root || document).querySelector(sel); };
  var qsa = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isDesktop = function () { return window.matchMedia('(min-width: 990px)').matches; };

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var format = JA.moneyFormat || '${{amount}}';
    cents = Number(cents) || 0;
    function withDelimiters(n, decimals, thousands, dec) {
      var fixed = (n / 100).toFixed(decimals);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(parts[1] ? dec : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelimiters(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(cents, 0, '.', ',');
        default: return withDelimiters(cents, 2, ',', '.');
      }
    });
  }

  /* ---------- Toast ---------- */
  function toast(msg) {
    var el = qs('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.hidden = true; }, 3200);
  }

  /* ---------- Drawers & modals ---------- */
  var Drawers = {
    current: null,
    trigger: null,
    get: function (name) { return qs('[data-drawer="' + name + '"]'); },
    open: function (name, trigger) {
      var el = this.get(name);
      if (!el) return;
      if (this.current && this.current !== el) this.close(true);
      this.current = el;
      this.trigger = trigger || document.activeElement;
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-locked', 'drawer-open');
      var overlay = qs('[data-overlay]');
      if (overlay) overlay.hidden = false;
      qsa('[data-drawer-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var focusTarget = qs('[data-predictive-input], input[type="search"]', el) || el;
      // Synchronous focus: rAF never fires while the browser pane is hidden.
      try { focusTarget.focus({ preventScroll: true }); } catch (e) { focusTarget.focus(); }
      el.dispatchEvent(new CustomEvent('drawer:open', { bubbles: true }));
    },
    close: function (keepOverlay) {
      var el = this.current;
      if (!el) return;
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      var name = el.getAttribute('data-drawer');
      qsa('[data-drawer-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      this.current = null;
      if (!keepOverlay) {
        document.body.classList.remove('is-locked', 'drawer-open');
        var overlay = qs('[data-overlay]');
        if (overlay) overlay.hidden = true;
        if (this.trigger && document.body.contains(this.trigger)) {
          try { this.trigger.focus({ preventScroll: true }); } catch (e) { /* noop */ }
        }
      }
    },
    trap: function (e) {
      var el = Drawers.current;
      if (!el || e.key !== 'Tab') return;
      var f = qsa('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', el)
        .filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  };
  JA.drawers = Drawers;

  // Drawers rendered inside the header section live under <body> so a sticky header's
  // stacking context can't trap them below the overlay.
  function hoistDrawers() {
    qsa('.section-site-header [data-drawer]').forEach(function (el) {
      var stale = document.body.querySelector(':scope > [data-drawer="' + el.getAttribute('data-drawer') + '"]');
      if (stale && stale !== el) stale.remove();
      document.body.appendChild(el);
    });
  }
  hoistDrawers();
  document.addEventListener('shopify:section:load', hoistDrawers);

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var name = opener.getAttribute('data-drawer-open');
      if (name === 'cart' && JA.cartType === 'page') return;
      if (Drawers.get(name)) {
        e.preventDefault();
        Drawers.open(name, opener);
      }
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.matches('[data-overlay]')) {
      e.preventDefault();
      Drawers.close();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var zoom = qs('[data-zoom]:not([hidden])');
      if (zoom) { closeZoom(zoom); return; }
      if (Drawers.current) Drawers.close();
    }
    Drawers.trap(e);
  });

  /* ---------- Mobile menu sub-lists ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-menu-toggle]');
    if (!t) return;
    var sub = document.getElementById(t.getAttribute('aria-controls'));
    var open = t.getAttribute('aria-expanded') === 'true';
    t.setAttribute('aria-expanded', String(!open));
    if (sub) sub.hidden = open;
  });

  /* ---------- Announcement rotation ---------- */
  qsa('[data-announcement]').forEach(function (bar) {
    var msgs = qsa('.announcement__msg', bar);
    if (msgs.length < 2 || bar.getAttribute('data-rotate') !== 'true') return;
    var i = 0;
    var speed = (parseInt(bar.getAttribute('data-speed'), 10) || 5) * 1000;
    function show(n) {
      msgs[i].classList.remove('is-active');
      msgs[i].setAttribute('aria-hidden', 'true');
      i = (n + msgs.length) % msgs.length;
      msgs[i].classList.add('is-active');
      msgs[i].removeAttribute('aria-hidden');
    }
    var timer = reduceMotion ? null : setInterval(function () { show(i + 1); }, speed);
    var prev = qs('[data-announcement-prev]', bar), next = qs('[data-announcement-next]', bar);
    if (prev) prev.addEventListener('click', function () { clearInterval(timer); show(i - 1); });
    if (next) next.addEventListener('click', function () { clearInterval(timer); show(i + 1); });
  });

  /* ---------- Hero slideshow ---------- */
  qsa('[data-slideshow]').forEach(function (root) {
    var slides = qsa('.hero__slide', root);
    var dots = qsa('[data-slide-to]', root);
    if (slides.length < 2) return;
    var i = 0, timer = null;
    function go(n) {
      slides[i].classList.remove('is-active');
      slides[i].setAttribute('aria-hidden', 'true');
      if (dots[i]) dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      slides[i].removeAttribute('aria-hidden');
      if (dots[i]) dots[i].classList.add('is-active');
    }
    dots.forEach(function (d) {
      d.addEventListener('click', function () { clearInterval(timer); go(parseInt(d.getAttribute('data-slide-to'), 10)); });
    });
    if (root.getAttribute('data-autoplay') === 'true' && !reduceMotion) {
      timer = setInterval(function () { go(i + 1); }, (parseInt(root.getAttribute('data-speed'), 10) || 6) * 1000);
      root.addEventListener('mouseenter', function () { clearInterval(timer); });
    }
  });

  /* ---------- Predictive search ---------- */
  (function () {
    var input = qs('[data-predictive-input]');
    var results = qs('[data-predictive-results]');
    if (!input || !results) return;
    var controller;
    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); return; }
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = routes.predictive + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page,query&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var inner = qs('.predictive__inner', parseHTML(html));
          results.innerHTML = inner ? inner.outerHTML : '';
          input.setAttribute('aria-expanded', inner ? 'true' : 'false');
        })
        .catch(function () { /* aborted or offline */ });
    }, 250);
    input.addEventListener('input', run);
  })();

  /* ---------- Cart ---------- */
  var Cart = {
    sectionIds: function () {
      var ids = ['cart-drawer', 'cart-json'];
      var page = qs('[data-cart-page]');
      if (page) {
        var wrap = page.closest('.shopify-section');
        if (wrap) ids.push(wrap.id.replace('shopify-section-', ''));
      }
      return ids;
    },
    render: function (sections) {
      if (!sections) return;
      if (sections['cart-drawer']) {
        var doc = parseHTML(sections['cart-drawer']);
        var fresh = qs('[data-cart-inner]', doc);
        var current = qs('[data-cart-inner]');
        if (fresh && current) current.replaceWith(fresh);
      }
      if (sections['cart-json']) {
        var node = qs('[data-cart-json]', parseHTML(sections['cart-json']));
        if (node) {
          try { this.updateCount(JSON.parse(node.textContent).item_count); } catch (e) { /* noop */ }
        }
      }
      var page = qs('[data-cart-page]');
      if (page) {
        var wrap = page.closest('.shopify-section');
        var id = wrap && wrap.id.replace('shopify-section-', '');
        if (id && sections[id]) {
          var freshPage = qs('[data-cart-page]', parseHTML(sections[id]));
          if (freshPage) page.replaceWith(freshPage);
        }
      }
      this.loadUpsell();
    },
    updateCount: function (n) {
      qsa('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
      qsa('[data-cart-count-text]').forEach(function (el) { el.textContent = n; });
    },
    pop: function () {
      if (reduceMotion) return;
      qsa('.site-header__bag').forEach(function (b) {
        b.classList.remove('is-popped');
        void b.offsetWidth;
        b.classList.add('is-popped');
      });
    },
    add: function (formData) {
      formData.append('sections', this.sectionIds().join(','));
      formData.append('sections_url', window.location.pathname);
      return fetch(routes.cartAdd + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      }).then(function (r) {
        return r.json().then(function (json) {
          if (!r.ok || json.status) throw new Error(json.description || json.message || 'Could not add to cart');
          return json;
        });
      }).then(function (json) {
        if (JA.cartType === 'page') { window.location.href = routes.cart; return json; }
        Cart.render(json.sections);
        Cart.pop();
        Drawers.open('cart');
        return json;
      });
    },
    change: function (line, quantity) {
      var drawer = qs('[data-cart-inner]');
      if (drawer) drawer.classList.add('is-busy');
      return fetch(routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: this.sectionIds(), sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); })
        .then(function (json) {
          if (json.status) { toast(json.description || json.message); }
          Cart.render(json.sections);
        })
        .catch(function () { toast('Something went wrong. Please try again.'); })
        .then(function () { var d = qs('[data-cart-inner]'); if (d) d.classList.remove('is-busy'); });
    },
    note: debounce(function (value) {
      fetch(routes.cartUpdate + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: value })
      });
    }, 500),
    loadUpsell: function () {
      var box = qs('[data-cart-upsell]');
      if (!box || box.dataset.loaded) return;
      var pid = box.getAttribute('data-product-id');
      if (!pid) return;
      box.dataset.loaded = '1';
      fetch(routes.recommendations + '?product_id=' + pid + '&limit=6&intent=related&section_id=cart-upsell')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var inner = qs('[data-upsell-ready]', parseHTML(html));
          if (inner && qsa('.cart-upsell__item', inner).length) {
            box.innerHTML = inner.outerHTML;
            box.hidden = false;
          }
        })
        .catch(function () { /* hide on failure */ });
    }
  };
  JA.cart = Cart;

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = qs('[data-add-btn]', form);
    var err = qs('[data-form-error]', form);
    if (btn && btn.disabled) return;
    if (err) err.hidden = true;
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    Cart.add(new FormData(form))
      .catch(function (error) {
        if (err) { err.textContent = error.message; err.hidden = false; }
        else toast(error.message);
      })
      .then(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
      });
  });

  document.addEventListener('click', function (e) {
    var line = e.target.closest('.cart-line');
    if (line) {
      var n = parseInt(line.getAttribute('data-line'), 10);
      var input = qs('[data-qty-input]', line);
      var qty = parseInt(input && input.value, 10) || 0;
      if (e.target.closest('[data-qty-minus]')) { e.preventDefault(); Cart.change(n, Math.max(0, qty - 1)); return; }
      if (e.target.closest('[data-qty-plus]')) { e.preventDefault(); Cart.change(n, qty + 1); return; }
      if (e.target.closest('[data-line-remove]')) { e.preventDefault(); Cart.change(n, 0); return; }
    }
    var up = e.target.closest('[data-upsell-add]');
    if (up) {
      e.preventDefault();
      var fd = new FormData();
      fd.append('id', up.getAttribute('data-upsell-add'));
      fd.append('quantity', '1');
      up.classList.add('is-loading');
      Cart.add(fd).catch(function (error) { toast(error.message); }).then(function () { up.classList.remove('is-loading'); });
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input) {
      var line = input.closest('.cart-line');
      Cart.change(parseInt(line.getAttribute('data-line'), 10), Math.max(0, parseInt(input.value, 10) || 0));
    }
  });
  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-cart-note]')) Cart.note(e.target.value);
  });
  document.addEventListener('drawer:open', function (e) {
    if (e.target.matches('[data-drawer="cart"]')) Cart.loadUpsell();
  });

  /* ---------- Product (PDP + quick view) ---------- */
  function Product(root) {
    this.root = root;
    var json = qs('[data-product-json]', root);
    if (!json) return;
    try { this.data = JSON.parse(json.textContent); } catch (e) { return; }
    this.updateUrl = root.getAttribute('data-update-url') === 'true';
    this.slides = qs('[data-slides]', root);
    this.index = 0;
    this.bind();
    this.syncAvailability();
    this.initGallery();
    this.initShipLine();
    this.initSticky();
    this.remember();
  }

  Product.prototype.selected = function () {
    var root = this.root;
    return qsa('[data-option-index]', root).map(function (fs) {
      var checked = qs('[data-option-input]:checked', fs);
      return checked ? checked.value : null;
    });
  };

  Product.prototype.findVariant = function (opts) {
    return this.data.variants.find(function (v) {
      return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === null || o === opts[i]; });
    });
  };

  Product.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-input]')) return;
      var fs = e.target.closest('[data-option-index]');
      var label = qs('[data-option-value]', fs);
      if (label) label.textContent = e.target.value;
      self.onChange();
    });
  };

  Product.prototype.onChange = function () {
    var opts = this.selected();
    var v = this.findVariant(opts);
    var root = this.root;
    var idInput = qs('[data-variant-id]', root);
    var btn = qs('[data-add-btn]', root);
    var addLabel = qs('[data-add-label]', root);
    var priceWrap = qs('[data-add-price-wrap]', root);
    this.syncAvailability();

    if (!v) {
      if (btn) btn.disabled = true;
      if (addLabel) addLabel.textContent = 'Unavailable';
      if (priceWrap) priceWrap.hidden = true;
      this.syncSticky(null);
      return;
    }
    if (idInput) idInput.value = v.id;
    var onSale = v.compare_at_price > v.price;
    qsa('[data-price-current]', root).forEach(function (el) { el.textContent = formatMoney(v.price); });
    qsa('[data-price-compare]', root).forEach(function (el) { el.textContent = formatMoney(v.compare_at_price); el.hidden = !onSale; });
    qsa('[data-sale-chip]', root).forEach(function (el) { el.hidden = !onSale; });
    var bnpl = qs('[data-bnpl]', root);
    if (bnpl) bnpl.textContent = bnpl.getAttribute('data-bnpl-template').replace('[amount]', formatMoney(Math.floor(v.price / 4)));
    if (btn) btn.disabled = !v.available;
    if (addLabel) addLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
    if (priceWrap) priceWrap.hidden = !v.available;
    var ap = qs('[data-add-price]', root), ac = qs('[data-add-compare]', root);
    if (ap) ap.textContent = formatMoney(v.price);
    if (ac) { ac.textContent = formatMoney(v.compare_at_price); ac.hidden = !onSale; }
    this.syncSticky(v);
    if (v.media_id) this.goToMedia(v.media_id);
    if (this.updateUrl) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
  };

  // Mark option values that can't be bought with the other current selections.
  Product.prototype.syncAvailability = function () {
    var self = this;
    var opts = this.selected();
    qsa('[data-option-index]', this.root).forEach(function (fs) {
      var idx = parseInt(fs.getAttribute('data-option-index'), 10);
      qsa('[data-option-input]', fs).forEach(function (input) {
        var test = opts.slice();
        test[idx] = input.value;
        var match = self.data.variants.find(function (v) {
          return v.available && v.options.every(function (o, i) { return test[i] === null || o === test[i]; });
        });
        var label = qs('label[for="' + input.id + '"]', fs);
        if (label) label.classList.toggle('is-unavailable', !match);
      });
    });
  };

  Product.prototype.initGallery = function () {
    var self = this, root = this.root, slides = this.slides;
    if (!slides) return;
    this.count = qsa('[data-slide]', slides).length;
    qsa('[data-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () { self.goTo(parseInt(t.getAttribute('data-thumb'), 10)); });
    });
    var prev = qs('[data-slide-prev]', root), next = qs('[data-slide-next]', root);
    if (prev) prev.addEventListener('click', function () { self.goTo(self.index - 1); });
    if (next) next.addEventListener('click', function () { self.goTo(self.index + 1); });
    var thumbs = qs('[data-thumbs]', root);
    var rp = qs('[data-rail-prev]', root), rn = qs('[data-rail-next]', root);
    if (thumbs && rp) rp.addEventListener('click', function () { thumbs.scrollBy({ top: -242, behavior: reduceMotion ? 'auto' : 'smooth' }); });
    if (thumbs && rn) rn.addEventListener('click', function () { thumbs.scrollBy({ top: 242, behavior: reduceMotion ? 'auto' : 'smooth' }); });
    slides.addEventListener('scroll', debounce(function () {
      var w = slides.clientWidth || 1;
      self.setActive(Math.round(slides.scrollLeft / w));
    }, 60), { passive: true });
    slides.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); self.goTo(self.index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.goTo(self.index - 1); }
    });
    // Start on the selected variant's image.
    var active = qs('.pdp__thumb.is-active', root);
    if (active) this.goTo(parseInt(active.getAttribute('data-thumb'), 10), true);

    var zoomBtn = qs('[data-zoom-open]', root);
    var zoom = qs('[data-zoom]', root);
    if (zoomBtn && zoom) {
      zoomBtn.addEventListener('click', function () { openZoom(zoom, self.index); });
      qsa('[data-slide] img', slides).forEach(function (img) {
        img.addEventListener('click', function () { openZoom(zoom, self.index); });
      });
      var close = qs('[data-zoom-close]', zoom);
      if (close) close.addEventListener('click', function () { closeZoom(zoom); });
    }
  };

  Product.prototype.goTo = function (i, instant) {
    if (!this.slides || !this.count) return;
    i = (i + this.count) % this.count;
    this.slides.scrollTo({ left: i * this.slides.clientWidth, behavior: instant || reduceMotion ? 'auto' : 'smooth' });
    this.setActive(i);
  };

  Product.prototype.goToMedia = function (mediaId) {
    var slide = qs('[data-slide][data-media-id="' + mediaId + '"]', this.root);
    // Colour change jumps straight to that colour's photo (EC behaviour).
    if (slide) this.goTo(parseInt(slide.getAttribute('data-slide'), 10), true);
  };

  Product.prototype.setActive = function (i) {
    this.index = i;
    var root = this.root;
    qsa('[data-thumb]', root).forEach(function (t) {
      var on = parseInt(t.getAttribute('data-thumb'), 10) === i;
      t.classList.toggle('is-active', on);
      if (on) {
        t.setAttribute('aria-current', 'true');
        var list = t.closest('[data-thumbs]');
        if (list) {
          var top = t.offsetTop - list.offsetTop;
          if (top < list.scrollTop || top + t.offsetHeight > list.scrollTop + list.clientHeight) {
            list.scrollTo({ top: top - 8, behavior: reduceMotion ? 'auto' : 'smooth' });
          }
        }
      } else t.removeAttribute('aria-current');
    });
    qsa('[data-dot]', root).forEach(function (d) { d.classList.toggle('is-active', parseInt(d.getAttribute('data-dot'), 10) === i); });
  };

  // "Ships by <date>": counts business days (Mon–Fri) from today.
  Product.prototype.initShipLine = function () {
    var line = qs('[data-ship-line]', this.root);
    var days = parseInt(JA.shipDays, 10);
    if (!line || isNaN(days) || days < 0) return;
    var d = new Date();
    var added = 0;
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) added++;
    }
    // EC format: "Shipped by: 23rd October"
    var n = d.getDate();
    var suffix = (n % 100 >= 11 && n % 100 <= 13) ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[n % 10] || 'th');
    var text = n + suffix + ' ' + d.toLocaleDateString('en-US', { month: 'long' });
    var target = qs('[data-ship-text]', line);
    target.innerHTML = 'Shipped by: <strong></strong>';
    qs('strong', target).textContent = text;
    line.hidden = false;
  };

  Product.prototype.initSticky = function () {
    var bar = qs('[data-sticky-atc]', this.root);
    var btn = qs('[data-add-btn]', this.root);
    if (!bar || !btn || !('IntersectionObserver' in window)) return;
    var self = this;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.hidden = e.isIntersecting || e.boundingClientRect.top > 0 || isDesktop();
    }).observe(btn);
    qs('[data-sticky-add]', bar).addEventListener('click', function () {
      var form = qs('form[data-product-form]', self.root);
      if (form) { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
    });
  };

  Product.prototype.syncSticky = function (v) {
    var bar = qs('[data-sticky-atc]', this.root);
    if (!bar) return;
    var price = qs('[data-sticky-price]', bar), b = qs('[data-sticky-add]', bar);
    if (price && v) price.textContent = formatMoney(v.price);
    if (b) { b.disabled = !v || !v.available; b.textContent = !v ? 'Unavailable' : v.available ? 'Add to cart' : 'Sold out'; }
  };

  Product.prototype.remember = function () {
    var handle = this.root.getAttribute('data-recent-handle');
    if (!handle) return;
    try {
      var list = JSON.parse(localStorage.getItem('ja:recent') || '[]').filter(function (h) { return h !== handle; });
      list.unshift(handle);
      localStorage.setItem('ja:recent', JSON.stringify(list.slice(0, 12)));
    } catch (e) { /* storage blocked */ }
  };

  // Fullscreen viewer: one image at a time with arrows, counter, keyboard and swipe.
  function showZoom(zoom, index) {
    var imgs = qsa('[data-zoom-img]', zoom);
    if (!imgs.length) return;
    var pos = imgs.findIndex(function (img) { return parseInt(img.getAttribute('data-zoom-img'), 10) === index; });
    if (pos < 0) pos = 0;
    zoom._pos = (pos + imgs.length) % imgs.length;
    imgs.forEach(function (img, i) {
      var on = i === zoom._pos;
      if (on && !img.src) img.src = img.getAttribute('data-src');
      img.hidden = !on;
    });
    var counter = qs('[data-zoom-counter]', zoom);
    if (counter) counter.textContent = (zoom._pos + 1) + ' / ' + imgs.length;
  }
  function stepZoom(zoom, dir) {
    var imgs = qsa('[data-zoom-img]', zoom);
    var next = imgs[(zoom._pos + dir + imgs.length) % imgs.length];
    showZoom(zoom, parseInt(next.getAttribute('data-zoom-img'), 10));
  }
  function openZoom(zoom, index) {
    if (!zoom._bound) {
      zoom._bound = true;
      qs('[data-zoom-prev]', zoom).addEventListener('click', function () { stepZoom(zoom, -1); });
      qs('[data-zoom-next]', zoom).addEventListener('click', function () { stepZoom(zoom, 1); });
      zoom.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') stepZoom(zoom, -1);
        if (e.key === 'ArrowRight') stepZoom(zoom, 1);
      });
      var x0 = null;
      zoom.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      zoom.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) stepZoom(zoom, dx < 0 ? 1 : -1);
        x0 = null;
      });
      qs('.zoom__stage', zoom).addEventListener('click', function (e) { if (e.target === e.currentTarget) closeZoom(zoom); });
    }
    showZoom(zoom, index);
    zoom.hidden = false;
    document.body.classList.add('is-locked');
    var close = qs('[data-zoom-close]', zoom);
    if (close) close.focus();
  }
  function closeZoom(zoom) {
    zoom.hidden = true;
    if (!Drawers.current) document.body.classList.remove('is-locked');
  }

  function initProducts(scope) {
    qsa('[data-product]', scope).forEach(function (root) {
      if (root._product) return;
      root._product = new Product(root);
    });
  }

  /* ---------- Quick view ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-view]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('data-quick-view');
    var content = qs('[data-quick-view-content]');
    if (!content) { window.location.href = url; return; }
    btn.classList.add('is-loading');
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=quick-view')
      .then(function (r) { if (!r.ok) throw new Error(); return r.text(); })
      .then(function (html) {
        var qv = qs('.qv', parseHTML(html));
        if (!qv) throw new Error();
        content.innerHTML = '';
        content.appendChild(qv);
        initProducts(content);
        Drawers.open('quick-view', btn);
      })
      .catch(function () { window.location.href = url; })
      .then(function () { btn.classList.remove('is-loading'); });
  });
  // Close quick view once its add succeeds (the bag drawer takes over).
  document.addEventListener('drawer:open', function (e) {
    if (e.target.matches('[data-drawer="cart"]')) {
      var c = qs('[data-quick-view-content]');
      if (c) c.innerHTML = '';
    }
  });

  /* ---------- Recommendations ("Wear it with") ---------- */
  qsa('[data-recommendations]').forEach(function (section) {
    var url = section.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var fresh = qs('[data-recommendations]', parseHTML(html));
      if (fresh && qs('.product-grid__item', fresh)) {
        section.innerHTML = fresh.innerHTML;
        section.hidden = false;
      }
    }).catch(function () { /* stay hidden */ });
  });

  /* ---------- Recently viewed ---------- */
  qsa('[data-recently-viewed]').forEach(function (section) {
    var list;
    try { list = JSON.parse(localStorage.getItem('ja:recent') || '[]'); } catch (e) { list = []; }
    var exclude = section.getAttribute('data-exclude');
    var limit = parseInt(section.getAttribute('data-limit'), 10) || 4;
    list = list.filter(function (h) { return h && h !== exclude; }).slice(0, limit);
    if (!list.length) return;
    Promise.all(list.map(function (h) {
      return fetch(routes.root.replace(/\/$/, '') + '/products/' + encodeURIComponent(h) + '?section_id=product-card-sra')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) { var li = html && qs('.product-grid__item', parseHTML(html)); return li ? li.outerHTML : ''; })
        .catch(function () { return ''; });
    })).then(function (items) {
      var html = items.join('');
      if (!html) return;
      qs('[data-recent-list]', section).innerHTML = html;
      section.hidden = false;
    });
  });

  /* ---------- Collection sort ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-sort]');
    if (!sel) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------- Footer columns collapse on mobile ---------- */
  (function () {
    var cols = qsa('[data-footer-col]');
    if (!cols.length) return;
    function sync() { var d = isDesktop(); cols.forEach(function (c) { c.open = d; }); }
    sync();
    var wasDesktop = isDesktop();
    window.addEventListener('resize', debounce(function () {
      if (isDesktop() !== wasDesktop) { wasDesktop = isDesktop(); sync(); }
    }, 150));
    cols.forEach(function (c) {
      qs('summary', c).addEventListener('click', function (e) { if (isDesktop()) e.preventDefault(); });
    });
  })();

  /* ---------- Account: sign in / reset toggle ---------- */
  (function () {
    var login = document.getElementById('Login'), recover = document.getElementById('Recover');
    if (!login || !recover) return;
    function show(which) { login.hidden = which !== 'login'; recover.hidden = which !== 'recover'; }
    if (window.location.hash === '#Recover' || qs('#Recover .form-success, #Recover .form-error')) show('recover');
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-account-toggle]');
      if (!a) return;
      e.preventDefault();
      show(a.getAttribute('href') === '#Recover' ? 'recover' : 'login');
    });
  })();

  /* ---------- Init ---------- */
  initProducts(document);
  JA.initProducts = initProducts;
  JA.formatMoney = formatMoney;
  window.JA = JA;
})();
